<template>
    <el-container>
        <el-aside :style="{width:aside+'%'}">
            <div class="logo">
                <span><img src="./assets/logo.png" alt=""></span>
                <span>亿通</span>
            </div>
            <el-menu
                :default-active="defalut"
                :router="false"
                @select="handleSelect"
            >
                <el-menu-item
                    v-for="{name, icon, router} in menus"
                    :key="router"
                    :index="router">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="'#icon--'+icon"></use>
                    </svg>
                    {{name}}
                </el-menu-item>

                <!--<a href="http://testshop.gzestars.com/" style="text-decoration:none">-->
                <!--<el-menu-item index="">-->
                    <!--<svg class="icon" aria-hidden="true">-->
                        <!--<use :xlink:href="'#icon&#45;&#45;'+'shoufeibiaozhun-xuanzhong'" ></use>-->
                    <!--</svg>-->
                    <!--返回商城-->
                <!--</el-menu-item>-->
                <!--</a>-->
                 <!-- <el-menu-item index="OrderList" v-if="user_type==1||user_type==2||user_type==3">
                 订单列表
                 </el-menu-item>
                 <el-menu-item index="Brokerage" v-if="user_type==1||user_type==2">佣金明细</el-menu-item>
                 <el-menu-item index="Report" v-if="user_type==1||user_type==2">订单报表</el-menu-item>
                 <el-menu-item index="Management" v-if="user_type==1||user_type==2">员工管理</el-menu-item>
                 <el-menu-item index="SupplyChain" v-if="user_type==1||user_type==2||user_type==3">供应链下单</el-menu-item>
                 <el-menu-item index="Charge" v-if="user_type==1||user_type==2">收费标准</el-menu-item> -->
            </el-menu>
        </el-aside>

        <el-container>
            <el-header>
                <img v-show="!isShow" class="sousuo" src="./assets/缩回菜单-01.png" alt="" @click="Hide"/>
                <img v-show="isShow" class="sousuo" src="./assets/展现菜单-01.png" alt="" @click="Shows"/>
                <el-card>
                    <!-- <img src="./assets/header/bag.png" alt=""/>
                    <span class="divider"/>
                    <img src="./assets/header/bell.png" alt=""/>
                    <span class="divider"/> -->
                    <el-popover
                        placement="bottom-end"
                        width="100"
                        trigger="hover"
                        popper-class="avatar_pop"
                    >
                        <div class="avatar_pop_content">
                            <!--<span @click="setUserInfoTab(1);$router.push('/UserInfo')">个人中心</span>-->
                            <!--<span @click="setUserInfoTab(3);$router.push('/UserInfo')">收货地址</span>-->
                            <span @click="logout">退出登录</span>
                        </div>
                        <div slot="reference" class="avatar">
                            <!--<img src="./assets/header/avatar.png" alt=""/>-->
                            <img src="http://www.icosky.com/icon/png/System/Scrap/Administrator%202.png" alt=""/>
                            <span>{{user_name}}</span>
                            <i class="el-icon-arrow-down"></i>
                        </div>
                    </el-popover>
                </el-card>
            </el-header>

            <el-main>
                <slot><router-view></router-view></slot>
            </el-main>
            <!--<el-main>-->
                <!--<solt>nothing</solt>-->
            <!--</el-main>-->
        </el-container>
    </el-container>
</template>

<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import { menus , menus2} from './utils/config';
    import { session_id } from './stores/api';

    export default {
        data () {
            let path = window.location.hash.replace('#/', '');
            if (path.indexOf('InstallTeamList') >= 0) {
                path = 'InstallTeamList';
            }
            return {
                user_name: localStorage.getItem('username'),
                defalut: path,
                menus: menus2,
                aside: 13,
                // user_type:'',
                // arr:'',
            };
        },
        async beforeMount () {
            // await this.getProvinceList();      //全局获取一次省份存入store
            // await this.getUserInfo();           //获取个人信息
        },
        methods: {
            // ...mapMutations(['setUserInfoTab']),
            // ...mapActions(['getProvinceList', 'getUserInfo']),
            handleSelect (index, indexPath) {
                if (window.location.hash.indexOf(index) < 0) {
                    this.$router.push('/' + index);
                }
            },
            logout () {
                window.localStorage.removeItem('azgs_session_id');
                // window.location.href = this.$reqUrl+'user.php';
                this.$router.push({path: '/'})
            },
            Hide() {
                this.isShow = !this.isShow
                this.aside = 0
            },
            Shows() {
                this.isShow = !this.isShow
                this.aside = 13
            },
            //获取user_type
            // getuser(c){
            //     this.$http.get(this.$reqUrl+'user.php?act=profile&session_id='+session_id)
            //     .then(res=>{
            //         this.user_type = res.data.userinfo.user_type
            //         this.arr = res.data.userinfo.position
            //         console.log(res.data)
            //         c&&c();
            //     })
            //     .catch(res=>{
            //         console.log(res)
            //     })
            // },
            //判断user_type
            // getUser_type() {
            //     this.menus = menus2
            //     if(this.user_type==1){
            //         this.menus = menus;
            //     }else if(this.user_type==3){
            //         this.menus = menus2;
            //     }else if(this.user_type==2){
            //         this.menus = menus;
            //         this.arr=this.arr.split(",");
            //         var a=this.menus;
            //         var b=this.arr;
            //         function  FilterData(a,b)
            //         {   //循环判断数组a里的元素在b里面有没有，有的话就放入新建立的数组中
            //             var result = new Array();
            //             var c=b.toString();
            //             for(var i=0;i<a.length;i++)
            //             {
            //               if(c.indexOf(a[i].router.toString())>-1)
            //               {
            //               result.push(a[i]);
            //               }
            //             }
            //             return result;
            //         }
            //         this.menus = FilterData(a,b)
            //         console.log(this.menus)
            //     }
            // }
        },
        computed: {
            ...mapState(['userInfo'])

        },
        mounted(){

            // this.getuser(()=>{this.getUser_type()})
        }
    };
</script>
<style lang="less" scoped>
    @import "default";

    @headHeight: 80px;
    .logo {
        height: @headHeight;
        display: flex;
        align-items: center;
        color: #FFF;
        font-size: 30px;
        font-weight: bold;
        letter-spacing: 20px;
        & > span:nth-child(1) {
            flex: 0.35;
            img {
                width: 56px;
                height: 36px;
                margin-right: 10px;
                float: right;
            }
        }
        & > span:nth-child(2) {
            flex: 0.6;
        }
    }
    .sousuo{
        position: absolute;
        cursor: pointer;
        margin-left: 25px;
        top: 25px;
        width: 30px;
        height: 30px;
    }
    .el-container {
        height: 100%;
        .el-header {
            height: @headHeight !important;
            padding: 0;
            font-size: 16px;
            z-index: 1;
            .el-card {
                height: 100%;
                /deep/ .el-card__body {
                    height: 100%;
                    padding: 0 40px;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    & > img {
                        width: 22px;
                        height: 24px;
                        cursor: pointer;
                    }
                    .divider {
                        height: 40px;
                    }
                    .avatar {
                        display: inline-flex;
                        align-items: center;
                        cursor: pointer;
                        & > img {
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                        }
                        & > span {
                            margin: 0 10px;
                        }
                        & > i {
                            font-size: 12px;
                        }
                    }
                }
            }

            .divider {
                display: inline-block;
                height: 16px;
                border-left: 1px solid rgba(199, 204, 212, 0.8);
                margin: 0 24px;
            }

        }
        .el-aside {
            /*width: 15% !important;*/
            background: #292b2e;
            .el-menu {
                background: #292b2e;
                border: 0;
                .el-menu-item {
                    font-size: 16px;
                    color: #FFF;
                    border-left: 3px solid #292b2e;
                    &:hover, &:focus, &.is-active {
                        background: #0e1014;
                        border-color: @orange;
                        .icon {
                            fill: @orange;
                        }
                    }

                    .icon {
                        width: 40px;
                        height: 20px;
                        fill: #FFF;
                    }
                }

            }
        }
        .el-main {
            padding: 35px 45px;
            background: #fafafa;
        }
    }


</style>
<style lang="less">
    .avatar_pop {
        margin-top: 25px !important;
        width: 200px !important;
        padding: 0 !important;
        .avatar_pop_content {
            display: flex;
            flex-direction: column;
            & > span {
                text-align: center;
                font-size: 14px;
                line-height: 45px;
                cursor: pointer;
                &:hover {
                    background: #2795f5;
                    color: #FFF;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/Container.vue